module.exports = __webpack_public_path__ + "static/media/JP_AS_EYELASHES04.b0a1ede0.jpg";